export enum MobileModalHeights {
  auto = 'ion-modal-touch auto-height',
  short = 'ion-modal-touch-short',
}
